import { z } from 'zod';
import { isoDateTimeSchema, softDeletableSchema, uuidSchema } from './common';

export const companyColorSchema = z
  .string()
  .regex(/^#[0-9A-Fa-f]{6}$/, 'Expected #RRGGBB hex color');
export type CompanyColor = z.infer<typeof companyColorSchema>;

export const companyInputSchema = z.object({
  name: z.string().trim().min(1).max(160),
  label: z.string().trim().min(1).max(80).optional(),
  aliases: z.array(z.string().trim().min(1).max(120)).max(20).default([]),
  color: companyColorSchema.default('#2563EB'),
  season: z.string().trim().min(1).max(80),
  active: z.boolean().default(true),
  notes: z.string().trim().max(5000).optional(),
});
export type CompanyInput = z.input<typeof companyInputSchema>;

export const companySchema = softDeletableSchema.extend({
  name: z.string(),
  label: z.string().nullable(),
  aliases: z.array(z.string()),
  color: companyColorSchema,
  season: z.string(),
  active: z.boolean(),
  notes: z.string().nullable(),
});
export type Company = z.infer<typeof companySchema>;

export const companyDancerLinkSchema = z.object({
  company_id: uuidSchema,
  dancer_id: uuidSchema,
  created_at: isoDateTimeSchema,
});
export type CompanyDancerLink = z.infer<typeof companyDancerLinkSchema>;

export const companyTeacherLinkSchema = z.object({
  company_id: uuidSchema,
  instructor_id: uuidSchema,
  created_at: isoDateTimeSchema,
});
export type CompanyTeacherLink = z.infer<typeof companyTeacherLinkSchema>;

export const companyClassLinkSchema = z.object({
  company_id: uuidSchema,
  class_id: uuidSchema,
  created_at: isoDateTimeSchema,
});
export type CompanyClassLink = z.infer<typeof companyClassLinkSchema>;

export const companyDanceLinkSchema = z.object({
  company_id: uuidSchema,
  dance_id: uuidSchema,
  created_at: isoDateTimeSchema,
});
export type CompanyDanceLink = z.infer<typeof companyDanceLinkSchema>;
